<template>
  <div class="typeTag">
    <div class="type1" v-if="type === 1">违约事实</div>
    <div class="type2" v-if="type === 2">高风险人员</div>
    <div class="type3" v-if="type === 3">其他</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    type: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {},
};
</script>

<style scoped lang="scss">
.type1,
.type2,
.type3 {
  height: 16px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  font-size: 10px;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
  line-height: 0;
  justify-content: center;
}
.type1 {
  background: linear-gradient(107deg, #f96c6c 0%, #e81010 100%);
  width: 52px;
}
.type2 {
  background: linear-gradient(104deg, #8d48ee 0%, #4b00b3 100%);
  width: 62px;
}
.type3 {
  background: linear-gradient(117deg, #33d1c9 0%, #2cb1bf 100%);
  width: 32px;
}
</style>
